/*
 * @Date: 2020-03-31 14:04:56
 * @LastEditors: yuanjianlong@aixuexi.com
 * @LastEditTime: 2020-04-14 11:47:51
 * @FilePath: \st-teacher-2020\src\plugins\indexPlugin.ts
 */
// import fullscreen from 'vue-fullscreen';
import filter from '@/filter';
import directive from '@/directive';

import $service from '@/service';
import $utils from '@/utils';
import Toast from '@/utils/toast';
import lodash from 'lodash';

export default {
  install(Vue: any) {
    // 1. 添加全局方法或属性
    Vue.prototype.$service = $service;
    Vue.prototype.$utils = $utils;
    Vue.prototype.$bus = new Vue();
    Vue.prototype.$toast = new Toast();
    Vue.prototype.$lodash = lodash;

    filter(Vue);
    directive(Vue);
  },

};
